<template>
    <table class="table table-bordered table-striped table-vcenter dataTable">
        <thead>
            <tr>
                <th>Supplier Name</th>
                <th>Invoice Number</th>
                <th>Invoice Date</th>
                <th>Total</th>
                <th>Vat Total</th>
                <th>Description</th>
                <th v-if="showApprovalDetails">Recorded Against</th>
                <th v-if="showUpdatedAt">Last Update</th>
                <th></th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script>
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        routes: Object,
        swal_data: {
            type: Object,
            required: false,
        },
        showUpdatedAt: {
            type: Boolean,
            default: false,
        },
        showApprovalDetails: {
            type: Boolean,
            default: false,
        },
    },
    mounted () {
        if (this.swal_data && this.swal_data.message) {
            Swal.fire(this.swal_data.message);
        }

        let columns = [
            {
                data: 'supplier_name',
            },
            {
                data: 'number',
            },
            {
                data: 'date',
            },
            {
                name: 'net_total', // search net_total and don't ask why
                data: 'total',
            },
            {
                data: 'vat_total',
            },
            {
                data: 'description',
                sortable: false,
            },
        ];

        if (this.showApprovalDetails) {
            columns.push({
                data: 'approval_details',
                sortable: false,
            });
        }

        if (this.showUpdatedAt) {
            columns.push({
                data: 'updated_at',
            });
        }

        columns.push({
            data: 'actions',
            sortable: false,
        });

        let table = window.jQuery(this.$el).DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: this.routes.table,
            },
            autoWidth: false,
            order: [[2, 'desc']],
            columns: columns
        });

        Eventbus.on('purchase-invoices-table-refresh', () => {
            table.ajax.reload(null, false);
        });

        let adjust = () => {
            this.$el.removeAttribute('style');
            table.columns.adjust();
        };

        if (document.getElementById('vehicle-purchase-invoices-tab')) {
            document.getElementById('vehicle-purchase-invoices-tab').addEventListener('shown.bs.tab', adjust);
        }
        if (document.getElementById('job-purchase-invoices-tab')) {
            document.getElementById('job-purchase-invoices-tab').addEventListener('shown.bs.tab', adjust);
        }
        if (document.getElementById('purchase-invoices-unapproved-tab')) {
            document.getElementById('purchase-invoices-unapproved-tab').addEventListener('shown.bs.tab', adjust);
        }
        if (document.getElementById('purchase-invoices-approved-tab')) {
            document.getElementById('purchase-invoices-approved-tab').addEventListener('shown.bs.tab', adjust);
        }

        table.on('draw', adjust);
    },
}
</script>
